<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="pa-4" flat>
        <v-row no-gutters>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-bold">
              {{ $t("card_subtitle") }}
            </v-card-subtitle>
          </v-col>

          <v-col
            class="pa-2 d-flex justify-space-between justify-md-end"
            cols="12"
            md="4"
          >
            <div class="rowinfo">
              <togetherAiUpgradeNew
                v-model="showUpgrade"
                :current-package.sync="currentPackage"
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-showUpgrade`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('upgrade_label')"
              />
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="rounded-lg me-2 info--text"
                  color="rgba(198, 198, 198, .3)"
                  small
                  v-bind="attrs"
                  @click="showUpgrade = true"
                  v-on="on"
                >
                  <v-icon left small>mdi-creation-outline</v-icon>
                  <span v-if="computedCurrentPackage">{{
                    computedCurrentPackage.count || "0"
                  }}</span>
                </v-chip>
              </template>
              <span v-if="computedCurrentPackage">
                {{
                  $t("remaining", {
                    count: computedCurrentPackage.count,
                    free: computedCurrentPackage.free ? $t("free") : "",
                  })
                }}
              </span>
            </v-tooltip>

            <v-menu offset-y open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="rounded-lg text-none"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-chevron-down</v-icon>
                  {{ $t(`lang_items.${langItems[selectedLang].value}`) }}
                  <v-icon right>mdi-web</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-subheader>{{ $t("language_select") }}</v-subheader>
                <v-list-item-group v-model="selectedLang" color="primary">
                  <v-list-item v-for="(item, i) in langItems" :key="i">
                    <v-list-item-icon class="py-1 me-2">
                      {{ item.flag }}
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        :v-text="$t(`lang_items.${item.value}`)"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-col>

          <v-col class="py-2" cols="12" md="4">
            <div class="rowinfo">
              <v-select
                v-model="sizeModel"
                :items="sizeItems"
                :menu-props="{ offsetY: true }"
                class="rounded-lg"
                dense
                hide-details
                :label="$t('image_size')"
                outlined
              >
                <template v-slot:prepend-inner>
                  <v-icon
                    >mdi-{{
                      sizeItems.find((s) => s.value === sizeModel).icon
                    }}</v-icon
                  >
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-icon class="me-2">
                    <v-icon>mdi-{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t(`size_items.${item.value}`) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-select>
              <help-info
                :element-name="`${serviceName}-${componentName}-sizeModel`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('image_size')"
              />
            </div>
          </v-col>
        </v-row>
        <div class="rowinfo" style="width: 100%">
          <v-textarea
            v-model="prompt"
            :loading="loading"
            :rules="[rules.empty, rules.spellChecker]"
            class="rounded-lg contentinfo"
            dense
            :label="$t('prompt_label')"
            outlined
            :placeholder="$t('prompt_placeholder')"
          >
            <template v-slot:append>
              <v-btn
                :color="regenerate ? 'orange' : 'success'"
                :disabled="!prompt || !allowGenerate || prompt.length < 3"
                :loading="loading || (isWriting && allowGenerate)"
                depressed
                @click="changeInput"
              >
                <v-icon v-if="regenerate" left>mdi-reload</v-icon>
                <v-icon v-else left>mdi-image-auto-adjust</v-icon>
                {{ $t(regenerate ? "regenerate_image" : "generate_image") }}
              </v-btn>
            </template>
          </v-textarea>
          <help-info
            :element-name="`${serviceName}-${componentName}-prompt`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('prompt_label')"
          />
        </div>

        <template v-if="!!result.at(indexAt)">
          <v-img
            :src="`data:image/png;base64,${result.at(indexAt).image}`"
            alt=""
            class="rounded-lg"
            contain
            width="100%"
          >
            <div class="pa-2 w-100">
              <div class="rowinfo" style="width: 100% !important">
                <v-btn
                  :loading="upLoading"
                  class="btn-accept rounded-lg ma-0 contnetinfo"
                  depressed
                  @click="saveImage"
                >
                  <v-icon left>mdi-content-save-plus-outline</v-icon>
                  {{ $t("save_image") }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-upLoading`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('save_image')"
                />
              </div>
            </div>
          </v-img>

          <v-card-subtitle class="pb-0">
            {{ $t("save_image_subtitle") }}
          </v-card-subtitle>
        </template>

        <div
          class="d-flex align-center py-4"
          style="
            max-width: 100%;
            max-height: 300px;
            overflow-x: auto;
            gap: 16px;
          "
        >
          <div
            v-for="(item, index) in result"
            :key="index"
            class="rounded-lg overflow-hidden cursor-pointer"
            style="
              user-select: none;
              max-width: 120px;
              width: 120px;
              min-width: 120px;
            "
            @click="indexAt = index"
          >
            <v-img
              :src="`data:image/png;base64,${item.image}`"
              alt=""
              :aspect-ratio="1"
              contain
              max-width="100%"
            />
          </div>
        </div>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import axios from "axios";
import { debounce } from "@/main";
import { base64ToBlob, saveOnCdnFiles } from "@/utilities/ImageGallery";
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper.vue";
import TogetherAiUpgradeNew from "@/view/components/adapters/AIGeneration/togetherAiUpgradeNew.vue";

export default {
  name: "togetherAiImage",
  components: { TogetherAiUpgradeNew, SwiperWrapper },
  data() {
    return {
      serviceName: "Qrland",
      componentName: "togetherAiImage",
      helpData: [],
      prompt: "",
      iterativeMode: false,
      showUpgrade: false,
      currentPackage: {},
      loading: false,
      result: [],
      indexAt: -1,
      upLoading: false,
      lastPrompt: "",
      sizeModel: "16:9",
      langItems: [
        {
          value: "fa",
          text: "",
          name: "فارسی",
          flag: "🇮🇷",
        },
        {
          value: "en",
          text: "",
          name: "English",
          flag: "🇬🇧",
        },
        {
          value: "ar",
          text: "",
          name: "العربية",
          flag: "🇸🇦",
        },
      ],
      sizeItems: [
        {
          value: "16:9",
          text: this.$t("size_items.16:9"),
          width: 1792,
          height: 1008,
          icon: "panorama-horizontal-outline",
        },
        {
          value: "9:16",
          text: this.$t("size_items.9:16"),
          width: 1008,
          height: 1792,
          icon: "panorama-vertical-outline",
        },
        {
          value: "1:1",
          text: this.$t("size_items.1:1"),
          width: 1024,
          height: 1024,
          icon: "square-outline",
        },
      ],
      translatedText: "",
      selectedLang: 0,
      isWriting: false,
    };
  },
  watch: {
    selectedLang(val) {
      this.prompt = "";
      this.translatedText = "";
      this.$i18n.locale = this.langItems[val].value; // Update locale
    },
    "$i18n.locale": {
      handler(newLocale) {
        this.updateTransition();
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    rules() {
      return {
        empty: (v) => !v || v.length >= 3 || this.$t("rules.empty"),
        spellChecker: (v) =>
          !v ||
          this.spellChecker(v) ||
          this.$t("rules.spell_checker", {
            language: this.computedSelectedLang.name,
          }),
      };
    },
    catName() {
      return this.$t("categories.generated_images");
    },
    regenerate() {
      let p =
        this.langItems[this.selectedLang].value === "fa"
          ? this.translatedText
          : this.prompt;
      return !!p && this.lastPrompt.trim() === p.trim();
    },
    computedSelectedLang() {
      return this.langItems[this.selectedLang];
    },
    allowGenerate() {
      return typeof this.rules.spellChecker(this.prompt) === "boolean";
    },
    computedCurrentPackage() {
      let packages = this.currentPackage;
      return packages.remaining instanceof Array
        ? packages.remaining.reduce((obj, curr) => {
            obj.free = false;
            if (!obj.hasOwnProperty("count"))
              obj.count = Number(curr.remaining);
            else obj.count += Number(curr.remaining);
            return obj;
          }, {})
        : {
            free: packages.package_id === null,
            count: packages.remaining,
          };
    },
  },
  mounted() {
    this.updateTransition();
  },
  methods: {
    updateTransition() {
      this.langItems[0].text = this.$t("lang_items.fa");
      this.langItems[1].text = this.$t("lang_items.en");
      this.langItems[2].text = this.$t("lang_items.ar");

      this.sizeItems[0].text = this.$t("size_items.16:9");
      this.sizeItems[1].text = this.$t("size_items.9:16");
      this.sizeItems[2].text = this.$t("size_items.1:1");
    },
    translatePrompt() {
      this.isWriting = true;
      this.$api
        .post(this.$aiApi + "/image/translate", {
          text: this.prompt.replace(/\n/g, " "),
          from: "fa",
          to: "en",
        })
        .then(({ data }) => {
          this.translatedText = Array.isArray(data.data)
            ? data.data[0]["destination-text"]
            : data.data["destination-text"];
        })
        .catch((err) => console.log(err))
        .finally(() => (this.isWriting = false));
    },
    changeInput() {
      this.loading = true;
      debounce(() => {
        this.getImage();
      }, 1000);
    },
    getImage() {
      let needPack = !this.computedCurrentPackage.count;
      let p = this.prompt;
      this.lastPrompt = p;
      let { width, height } = this.sizeItems.find(
        (item) => item.value === this.sizeModel
      );

      if (!width || !height) {
        this.loading = false;
        return this.$toast.warning(this.$t("errors.invalid_size"));
      }
      if (p?.trim() !== "") {
        this.$api
          .post(this.$aiApi + "/image/generate/image", {
            width: Number(width),
            height: Number(height),
            prompt: p,
            steps: 3,
            type: "base64",
          })
          .then(({ data }) => {
            let { base64, ...rest } = data;
            this.currentPackage = data.data[0].package;
            if (needPack && !this.currentPackage.remaining) {
              this.showUpgrade = true;
              this.$toast.info(
                rest.message || this.$t("errors.image_generation_error")
              );
            }
            if (data.data[0].base64.length > 0) {
              this.result.push({
                image: data.data[0].base64,
                prompt: p,
                checked: false,
              });
              this.indexAt = -1;
            }
          })
          .catch(({ response }) => {
            this.$toast.error(
              response?.data?.error?.message ||
                this.$t("errors.image_generation_error")
            );
            console.error(response);
          })
          .finally(() => (this.loading = false));
      }
    },
    saveImage() {
      this.upLoading = true;
      const base64String = this.result.at(this.indexAt).image;
      const mimeType = "application/octet-stream";
      const fileBlob = base64ToBlob(base64String, mimeType);
      saveOnCdnFiles(
        fileBlob,
        this.result.at(this.indexAt).prompt.replace(/ /g, "_"),
        this.catName
      )
        .then((response) => {
          this.$emit("saved", this.catName);
        })
        .catch((error) => {
          this.$toast.error(this.$t("errors.image_upload_error"));
        })
        .finally(() => (this.upLoading = false));
    },
    spellChecker(input) {
      const reg = {
        en: /[\u0600-\u06FF\u06F0-\u06F9]+/,
        fa: /[A-Za-z]+/,
        ar: /[A-Za-z]+/,
      };
      return Array.from(input).every(
        (char) => !reg[this.computedSelectedLang.value].test(char)
      );
    },
  },
};
</script>

<style scoped></style>
